import Diagnostics from "@/modules/activities/diagnostic/components/diagnostic"
import type { Location } from "react-router-dom"
import { Navigate, useLocation, useParams } from "react-router-dom"

export interface DiagnosticIdPageState {
  name: string
  course: string
  id: string
  userWeeklyObjectiveId: string
}

export default function DiagnosticIdPage() {
  const location: Location<DiagnosticIdPageState> = useLocation()
  const { id } = useParams<{ id: string }>()
  if (!id || !location.state) return <Navigate to="/activities/diagnostic/notFound" replace />

  return (
    <div className="flex min-h-screen w-full">
      <Diagnostics
        course={location.state.course}
        name={location.state.name}
        id={id}
        userActivityId={location.state.id}
        userWeeklyObjectiveId={location.state.userWeeklyObjectiveId}
      />
    </div>
  )
}
